<div class="schedule-page jobsv2-{{ colorScheme.colorScheme.value }}">
    <!-- Sticky page header (ask: "sticky the header/tabs to the top of the
         page ... for all the tabs"): the tab strip AND the shared controls
         bar (date picker, arrows, money/capacity strip) stay pinned to the
         top of .layout-main while long boards scroll underneath. The
         breadcrumb rides along so the crumb switcher never disappears. The
         block's measured height feeds --calendar-header-height, which pins
         FullCalendar's sticky thead BELOW it (see schedules.component). -->
    <div class="schedule-sticky-header">
        <!-- Tabs ABOVE the date header (Ray): breadcrumbs, then the tab strip,
             then the shared date/controls bar, then the tab content. The bar is
             one per page (DRY) driven by the active tab's registered
             ScheduleControlsConfig; only its DOM position changed. -->
        <div class="schedule-page-header">
            <!-- Plain PrimeNG breadcrumb, same primitives as the dashboards (Ray:
                 align the schedules' crumbs with the other pages). -->
            <p-breadcrumb [home]="home" [model]="breadcrumb" styleClass="p-mb-2">
                <ng-template pTemplate="item" let-item>
                    <!-- PrimeNG 17 only invokes a command-only crumb's command from
                         its CLICK handler (the generated anchor has no href) —
                         keyboard users must reach it too (CodeRabbit). The focusable
                         span carries Enter/Space (positioned by the event, like the
                         click) and never a nested button inside the anchor. -->
                    <span
                        class="p-menuitem-text"
                        [class.crumb-static]="!item.command"
                        [attr.aria-current]="item.command ? 'page' : null"
                        [attr.tabindex]="item.command ? 0 : null"
                        [attr.role]="item.command ? 'button' : null"
                        [attr.aria-haspopup]="item.command ? 'menu' : null"
                        (keydown.enter)="$event.preventDefault(); item.command && item.command({ originalEvent: $event })"
                        (keydown.space)="$event.preventDefault(); item.command && item.command({ originalEvent: $event })"
                    >{{ item.label }}</span>
                </ng-template>
            </p-breadcrumb>
        </div>
        <app-karve-tabview
            [tabs]="tabs"
            baseUrl="/schedule"
            class="schedule-tabs"
        ></app-karve-tabview>
        <app-schedule-controls-bar class="schedule-controls"></app-schedule-controls-bar>
    </div>
    <div class="tab-content" [class.tab-content-flush]="flushScheduleTab">
        <router-outlet></router-outlet>
    </div>
  <!-- Page picker for the clickable crumbs. -->
  <p-menu
    #pageMenuTrigger
    [popup]="true"
    [model]="pageMenu"
    appendTo="body"
  ></p-menu>
</div>